import { Input } from 'antd';
import { Param } from '../../cliDataSchema';
import ParamFormItem from './ParamFormItem';
import React from 'react';

type Props = {
  param: Param;
  visibleParams: Param[];
};

const IntOption = ({ param, visibleParams }: Props) => {
  const [disabled, setDisabled] = React.useState(false);
  return (
    <ParamFormItem
      param={param}
      disabled={disabled}
      setDisabled={setDisabled}
      visibleParams={visibleParams}
    >
      <Input type="number" disabled={disabled} />
    </ParamFormItem>
  );
};

export default IntOption;
